// External imports
import React, { useEffect, useState } from "react";
import {
    ActiveTestimonial,
    TestimonialSection,
    Dots,
    TestimonialContainer,
    TestimonialDots,
    TestimonialTitle,
    TestimonialSubTitle,
    TestimonialSectionSpan,
} from "./testimonials.styles";
import { FaArrowRight, FaQuoteLeft } from "react-icons/fa";

// Internal imports

/**
 * Props for the Testimonial component
 * @property title - Title of the about
 * @property detail - Description or details of about
 */
interface testimonialsProps {
    testimonial: string[];
    translations: any;
}

/**
 * AboutCard component
 * Displays a about card with title, detail
 *
 */

const Testimonials: React.FC<testimonialsProps> = ({ testimonial, translations }) => {
    const [activeIndex, setActiveIndex] = useState(0);
    useEffect(() => {
        const interval = setInterval(() => {
            setActiveIndex((prevIndex) => (prevIndex + 1) % testimonial.length);
        }, 4000);
        return () => clearInterval(interval);
    }, [testimonial.length]);
    return (
        <TestimonialContainer>
            <TestimonialTitle>{translations.testimonialsTitle}</TestimonialTitle>
            {/* <TestimonialSubTitle>Some of the most memorable feedbacks</TestimonialSubTitle> */}
            <ActiveTestimonial>
                <TestimonialSection>
                    <TestimonialSectionSpan>
                        <FaQuoteLeft />
                    </TestimonialSectionSpan>
                    {testimonial[activeIndex]}
                </TestimonialSection>
            </ActiveTestimonial>
            <TestimonialDots>
                {testimonial.map((_, index) => (
                    <Dots
                        key={index}
                        onClick={() => setActiveIndex(index)}
                        className={activeIndex === index ? "active" : ""}
                    />
                ))}
            </TestimonialDots>
            
        </TestimonialContainer>
    );
};

export default Testimonials;
